export const croreLabel = 'Per Crore';
export const BrokerageChargeType = {
  NSEIPFT: 'nseipft',
  SEBI: 'sebi',
  BROKERAGE: 'brokerage',
  STT: 'stt',
  EXCHANGETRANSACTION: 'exchangeTransaction',
  STAMPDUTY: 'stampDuty',
  GST: 'gst',
} as const;

export const TransactionChargeLabels = {
  nseipft: 'NSE IPFT',
  sebi: 'SEBI',
  brokerage: 'BROKERAGE',
  stt: 'STT',
  exchangeTransaction: 'EXCHANGE TRANSACTION',
  stampDuty: 'STAMP DUTY',
  gst: 'GST',
} as const;
